var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.538,
    height: 11.538,
    viewBox: "0 0 11.538 11.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,8.427a.934.934,0,0,1-.75-.4l-.577-.769s-.024-.01-.034-.01H2.663C1.019,7.25,0,6.8,0,4.586V2.663A2.326,2.326,0,0,1,2.274.019,3.246,3.246,0,0,1,2.663,0H5.74A2.383,2.383,0,0,1,8.4,2.663V4.586a2.763,2.763,0,0,1-.024.4A2.317,2.317,0,0,1,5.74,7.25H5.548l-.6.779A.934.934,0,0,1,4.2,8.427ZM2.663.721q-.166,0-.317.014C1.231.832.721,1.442.721,2.663V4.586c0,1.649.51,1.942,1.942,1.942h.192a.8.8,0,0,1,.6.293l.577.774a.193.193,0,0,0,.346,0l.577-.769a.742.742,0,0,1,.6-.3H5.74c1.221,0,1.832-.514,1.923-1.61a2.609,2.609,0,0,0,.019-.332V2.663c0-1.341-.6-1.942-1.942-1.942Z",
    transform: "translate(0.601 2.524)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.481.961A.481.481,0,1,1,.962.481.479.479,0,0,1,.481.961Z",
    transform: "translate(4.322 5.86)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.481.961A.481.481,0,1,1,.962.481.479.479,0,0,1,.481.961Z",
    transform: "translate(5.86 5.86)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.481.961A.481.481,0,1,1,.962.481.479.479,0,0,1,.481.961Z",
    transform: "translate(2.788 5.86)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.078,7.23a.356.356,0,0,1-.26-.111.349.349,0,0,1-.1-.293,2.251,2.251,0,0,0,.019-.317V4.586c0-1.341-.6-1.942-1.942-1.942H.722q-.166,0-.317.014a.365.365,0,0,1-.293-.1A.366.366,0,0,1,0,2.274,2.323,2.323,0,0,1,2.645,0H5.722A2.383,2.383,0,0,1,8.386,2.663V4.586A2.326,2.326,0,0,1,6.112,7.23ZM.78,1.923H3.795A2.383,2.383,0,0,1,6.458,4.586v1.86c.817-.2,1.2-.8,1.2-1.86V2.663c0-1.341-.6-1.942-1.942-1.942H2.641C1.583.721.987,1.106.78,1.923Z",
    transform: "translate(2.547 0.601)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.538V11.538H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeak);
export default __webpack_public_path__ + "static/media/speak.f9f1c294f8ceb7fc33707b0aceb2aee8.svg";
export { ForwardRef as ReactComponent };